// extracted by mini-css-extract-plugin
module.exports = {"markdownContent":"MarkdownContent_markdownContent__clmFL"};